import React from "react";

export default function RankDropdown({
  value,
  onChange,
  label = "Grade Level",
  required = false,
  showLabel = true,
  error,
}) {
  const ranks = ["GL 9", "GL 10", "GL 11", "GL 12", "GL 13", "GL 14", "GL 15"];

  return (
    <div className="mb-4">
      {/* Show label only if showLabel === true */}
      {showLabel && (
        <label className="block font-medium mb-1">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className={`w-full border rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-400 focus:border-blue-400 outline-none transition ${
          error ? "border-red-500" : "border-gray-300"
        }`}
      >
        {/* Placeholder adjusts if label hidden */}
        <option value="">{showLabel ? `Select ${label}` : label}</option>
        {ranks.map((rank) => (
          <option key={rank} value={rank}>
            {rank}
          </option>
        ))}
      </select>

      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
}
